(function() {
    var PaymentMethodSubmitButton = function ($el) {
        this.$el = $el
        this.$dropdown = this.$el.find('.dropdown-toggle')
        this.$paymentButtons = this.$el.find('button[name=payment_method]')

        this.$paymentButtons.on('click', this.disableDropdown.bind(this))

        return this
    }

    PaymentMethodSubmitButton.prototype.disableDropdown = function () {
        this.$dropdown.prop('disabled', true)
        this.$dropdown.children().hide()
        this.$dropdown.find('.glyphicon-refresh')
            .removeClass('collapse')
            .fadeIn()

        return this
    }

    $('.payment-methods-submit-button').each(function () {
        new PaymentMethodSubmitButton($(this))
    })
})()
